var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FwButton',{staticClass:"b-add-edit__form__save-button",attrs:{"color":"transparent","fontSize":"12px","disabled":_vm.disabled}},[_c('p',{staticClass:"b-add-edit__form__save"},[_vm._v(" "+_vm._s(_vm.$t('BUTTON.SAVE'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }